/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AppRouteImport } from './routes/app'
import { Route as CustomerRouteImport } from './routes/customer'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAccountMappingRouteImport } from './routes/app/account-mapping'
import { Route as AppAdjustmentsRouteImport } from './routes/app/adjustments'
import { Route as AppAuditHistoryRouteImport } from './routes/app/audit-history'
import { Route as AppCompanySetupRouteImport } from './routes/app/company-setup'
import { Route as AppConnectionsRouteImport } from './routes/app/connections'
import { Route as AppKpisRouteImport } from './routes/app/kpis'
import { Route as AppOpportunitiesRouteImport } from './routes/app/opportunities'
import { Route as AppOverviewRouteImport } from './routes/app/overview'
import { Route as AppPeopleAccessRouteImport } from './routes/app/people-access'
import { Route as AppSourceReconciliationRouteImport } from './routes/app/source-reconciliation'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerRoute = CustomerRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountMappingRoute = AppAccountMappingRouteImport.update({
  id: '/account-mapping',
  path: '/account-mapping',
  getParentRoute: () => AppRoute,
} as any)
const AppAdjustmentsRoute = AppAdjustmentsRouteImport.update({
  id: '/adjustments',
  path: '/adjustments',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditHistoryRoute = AppAuditHistoryRouteImport.update({
  id: '/audit-history',
  path: '/audit-history',
  getParentRoute: () => AppRoute,
} as any)
const AppCompanySetupRoute = AppCompanySetupRouteImport.update({
  id: '/company-setup',
  path: '/company-setup',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectionsRoute = AppConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AppRoute,
} as any)
const AppKpisRoute = AppKpisRouteImport.update({
  id: '/kpis',
  path: '/kpis',
  getParentRoute: () => AppRoute,
} as any)
const AppOpportunitiesRoute = AppOpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => AppRoute,
} as any)
const AppOverviewRoute = AppOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleAccessRoute = AppPeopleAccessRouteImport.update({
  id: '/people-access',
  path: '/people-access',
  getParentRoute: () => AppRoute,
} as any)
const AppSourceReconciliationRoute = AppSourceReconciliationRouteImport.update({
  id: '/source-reconciliation',
  path: '/source-reconciliation',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/app': typeof AppRouteWithChildren
  '/customer': typeof CustomerRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/app/account-mapping': typeof AppAccountMappingRoute
  '/app/adjustments': typeof AppAdjustmentsRoute
  '/app/audit-history': typeof AppAuditHistoryRoute
  '/app/company-setup': typeof AppCompanySetupRoute
  '/app/connections': typeof AppConnectionsRoute
  '/app/kpis': typeof AppKpisRoute
  '/app/opportunities': typeof AppOpportunitiesRoute
  '/app/overview': typeof AppOverviewRoute
  '/app/people-access': typeof AppPeopleAccessRoute
  '/app/source-reconciliation': typeof AppSourceReconciliationRoute
  '/app/': typeof AppIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/customer': typeof CustomerRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/app/account-mapping': typeof AppAccountMappingRoute
  '/app/adjustments': typeof AppAdjustmentsRoute
  '/app/audit-history': typeof AppAuditHistoryRoute
  '/app/company-setup': typeof AppCompanySetupRoute
  '/app/connections': typeof AppConnectionsRoute
  '/app/kpis': typeof AppKpisRoute
  '/app/opportunities': typeof AppOpportunitiesRoute
  '/app/overview': typeof AppOverviewRoute
  '/app/people-access': typeof AppPeopleAccessRoute
  '/app/source-reconciliation': typeof AppSourceReconciliationRoute
  '/app': typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/app': typeof AppRouteWithChildren
  '/customer': typeof CustomerRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/app/account-mapping': typeof AppAccountMappingRoute
  '/app/adjustments': typeof AppAdjustmentsRoute
  '/app/audit-history': typeof AppAuditHistoryRoute
  '/app/company-setup': typeof AppCompanySetupRoute
  '/app/connections': typeof AppConnectionsRoute
  '/app/kpis': typeof AppKpisRoute
  '/app/opportunities': typeof AppOpportunitiesRoute
  '/app/overview': typeof AppOverviewRoute
  '/app/people-access': typeof AppPeopleAccessRoute
  '/app/source-reconciliation': typeof AppSourceReconciliationRoute
  '/app/': typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/app'
    | '/customer'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/app/account-mapping'
    | '/app/adjustments'
    | '/app/audit-history'
    | '/app/company-setup'
    | '/app/connections'
    | '/app/kpis'
    | '/app/opportunities'
    | '/app/overview'
    | '/app/people-access'
    | '/app/source-reconciliation'
    | '/app/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invitation'
    | '/customer'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/app/account-mapping'
    | '/app/adjustments'
    | '/app/audit-history'
    | '/app/company-setup'
    | '/app/connections'
    | '/app/kpis'
    | '/app/opportunities'
    | '/app/overview'
    | '/app/people-access'
    | '/app/source-reconciliation'
    | '/app'
  id:
    | '__root__'
    | '/'
    | '/accept-invitation'
    | '/app'
    | '/customer'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/app/account-mapping'
    | '/app/adjustments'
    | '/app/audit-history'
    | '/app/company-setup'
    | '/app/connections'
    | '/app/kpis'
    | '/app/opportunities'
    | '/app/overview'
    | '/app/people-access'
    | '/app/source-reconciliation'
    | '/app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  AppRoute: typeof AppRouteWithChildren
  CustomerRoute: typeof CustomerRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer': {
      id: '/customer'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof CustomerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/account-mapping': {
      id: '/app/account-mapping'
      path: '/account-mapping'
      fullPath: '/app/account-mapping'
      preLoaderRoute: typeof AppAccountMappingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/adjustments': {
      id: '/app/adjustments'
      path: '/adjustments'
      fullPath: '/app/adjustments'
      preLoaderRoute: typeof AppAdjustmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/audit-history': {
      id: '/app/audit-history'
      path: '/audit-history'
      fullPath: '/app/audit-history'
      preLoaderRoute: typeof AppAuditHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/company-setup': {
      id: '/app/company-setup'
      path: '/company-setup'
      fullPath: '/app/company-setup'
      preLoaderRoute: typeof AppCompanySetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/connections': {
      id: '/app/connections'
      path: '/connections'
      fullPath: '/app/connections'
      preLoaderRoute: typeof AppConnectionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/kpis': {
      id: '/app/kpis'
      path: '/kpis'
      fullPath: '/app/kpis'
      preLoaderRoute: typeof AppKpisRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/opportunities': {
      id: '/app/opportunities'
      path: '/opportunities'
      fullPath: '/app/opportunities'
      preLoaderRoute: typeof AppOpportunitiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/overview': {
      id: '/app/overview'
      path: '/overview'
      fullPath: '/app/overview'
      preLoaderRoute: typeof AppOverviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/people-access': {
      id: '/app/people-access'
      path: '/people-access'
      fullPath: '/app/people-access'
      preLoaderRoute: typeof AppPeopleAccessRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/source-reconciliation': {
      id: '/app/source-reconciliation'
      path: '/source-reconciliation'
      fullPath: '/app/source-reconciliation'
      preLoaderRoute: typeof AppSourceReconciliationRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountMappingRoute: typeof AppAccountMappingRoute
  AppAdjustmentsRoute: typeof AppAdjustmentsRoute
  AppAuditHistoryRoute: typeof AppAuditHistoryRoute
  AppCompanySetupRoute: typeof AppCompanySetupRoute
  AppConnectionsRoute: typeof AppConnectionsRoute
  AppKpisRoute: typeof AppKpisRoute
  AppOpportunitiesRoute: typeof AppOpportunitiesRoute
  AppOverviewRoute: typeof AppOverviewRoute
  AppPeopleAccessRoute: typeof AppPeopleAccessRoute
  AppSourceReconciliationRoute: typeof AppSourceReconciliationRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountMappingRoute: AppAccountMappingRoute,
  AppAdjustmentsRoute: AppAdjustmentsRoute,
  AppAuditHistoryRoute: AppAuditHistoryRoute,
  AppCompanySetupRoute: AppCompanySetupRoute,
  AppConnectionsRoute: AppConnectionsRoute,
  AppKpisRoute: AppKpisRoute,
  AppOpportunitiesRoute: AppOpportunitiesRoute,
  AppOverviewRoute: AppOverviewRoute,
  AppPeopleAccessRoute: AppPeopleAccessRoute,
  AppSourceReconciliationRoute: AppSourceReconciliationRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInvitationRoute: AcceptInvitationRoute,
  AppRoute: AppRouteWithChildren,
  CustomerRoute: CustomerRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
